import { init } from 'components/link/builder';

const linksA2 = {
  project: 'a2',
  // Home
  sectionA2: props => ({
    href: `/${props.langPrefix.replace('/', '')}`,
    title: props.title || props.name
  })
};

export default init(linksA2);
